@if (product) {
  <kp-branding-icon class="hidden-screen" [product]="product"></kp-branding-icon>
}
<span>&copy;&nbsp;{{ includeProMedica ? 'ProMedica and ' : '' }}Kumanu, {{ year }}.</span>
<span>All rights reserved.</span>
@if (includeKumanuTrademark) {
  <span>{{ productDisplayName }} by Kumanu is a trademark of Kumanu Inc.</span>
}
